// extracted by mini-css-extract-plugin
export default {"form":"NewCommentForm_form__C3cQf","loading":"NewCommentForm_loading__aSq20","control":"NewCommentForm_control__iR6jS","actions":"NewCommentForm_actions__NC323"};